// extracted by mini-css-extract-plugin
export var icon = "socialLinksNav-module--icon--ba928";
export var instagram = "socialLinksNav-module--instagram--7ffd0";
export var isHeader = "socialLinksNav-module--isHeader--7df11";
export var linkedin = "socialLinksNav-module--linkedin--28732";
export var socialLinksNav = "socialLinksNav-module--socialLinksNav--bd578";
export var threads = "socialLinksNav-module--threads--2b33a";
export var twitter = "socialLinksNav-module--twitter--cda2a";
export var youtube = "socialLinksNav-module--youtube--c9a9d";